import { render } from "./cliente-dropdown-item.vue?vue&type=template&id=4bd1e0ad&scoped=true"
import script from "./cliente-dropdown-item.vue?vue&type=script&lang=js"
export * from "./cliente-dropdown-item.vue?vue&type=script&lang=js"

import "./cliente-dropdown-item.vue?vue&type=style&index=0&id=4bd1e0ad&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd1e0ad"]])

export default __exports__